import styled from "styled-components";

import { Loading } from "../Loading";

export const BigLoading = styled(Loading)`
    left: 0;
    text-align: center;
    top: 20%;
    position: absolute;
    width: 100%;
`;
